import { __extends } from "tslib";
import React from 'react';
import { withTranslation } from 'react-i18next';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import CommentIcon from '@wix/da-ds/pkg/Icons/24x24/Comment';
import Notification from '../Notifications/Notification';
import SystemNotification from '../SystemNotification';
var CommentDeleteNotification = /** @class */ (function (_super) {
    __extends(CommentDeleteNotification, _super);
    function CommentDeleteNotification() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onUndo = function () {
            _this.props.onUnhide(_this.props.comment);
        };
        return _this;
    }
    CommentDeleteNotification.prototype.render = function () {
        var _a;
        var _b = this.props, id = _b.id, t = _b.t, queueName = _b.queueName, comment = _b.comment, insideModal = _b.insideModal, isCommentReduxReady = _b.isCommentReduxReady;
        return (React.createElement(Notification, { id: id, queueName: queueName, cardComponent: SystemNotification, cardProps: {
                iconComponent: CommentIcon,
                actions: [
                    {
                        type: 'negative',
                        label: t('comment.action.delete.undo'),
                        onClick: this.onUndo,
                        disabled: !isCommentReduxReady,
                        biData: {
                            evid: BiEventType.COMMENT_DELETION_UNDO,
                            commenterid: (_a = comment.user) === null || _a === void 0 ? void 0 : _a.useridUuid,
                            commentid: comment.commentId,
                            itemid: comment.itemId,
                            typeid: comment.typeId,
                            is_comment_thread: insideModal ? 1 : undefined,
                        },
                    },
                ],
            } }, t('comment.info.deleted')));
    };
    return CommentDeleteNotification;
}(React.Component));
export { CommentDeleteNotification };
export default withTranslation()(CommentDeleteNotification);
//# sourceMappingURL=CommentDeleteNotification.js.map